// A hub user's one-hour session in this department (#2307) has passed its end
// time: the api answers every call with this code until they sign out (see
// api/src/lib/hubSession.js). Kept apart from data/session.js so the many tests
// that mock that module needn't know about it.
export const HUB_SESSION_EXPIRED_CODE = 'hub-session-expired';
export const HUB_SESSION_ENDED_MESSAGE = 'Your hub session has ended. Open the department from the hub again to continue.';
